

import { Avatar, Box, Card, CardContent, Grid, makeStyles, Paper, Typography } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import HomeHeaderMenu from '../../Home/HomeHeaderMenu';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import { AddShoppingCart } from '@material-ui/icons';
import LinearProgress from '@material-ui/core/LinearProgress';
import DataService from '../../../Service';
import { IconButton } from '@material-ui/core';
import MoreVertIcon from "@material-ui/icons/MoreVert";
import Menu from "@material-ui/core/Menu";
import { MenuItem } from '@material-ui/core';
import { useHistory } from 'react-router';
import ViewSummary from "./view_summary";


const rawData: any = [];
const ITEM_HEIGHT = 48;
const options1 = ["View summary", "View details"];
const CoachHome = () => {
  const classes = useStyles();
  const menues = [
    { apiLabel: "", label: "All" },
    { apiLabel: "In Progress", label: "In progress" },
    { apiLabel: "completed", label: "Completed" },
    { apiLabel: "to_be_started", label: "To be started" },
    { apiLabel: "shortlist", label: "Shortlist" },
    { apiLabel: "chemistry", label: "Chemistry" },
    { apiLabel: "cancelled", label: "Cancelled" },
  
  ]
  //
  const [data, setData] = useState<any>(rawData);
  const [anchorEl, setAnchorEl] = useState(null);
  const [modules, setModules] = useState<any>(null);
  const [action, setAction] = useState<any>("");
  const [currentSelection, setCurrentSelection] = useState<any>({});
  const open = Boolean(anchorEl);
  const i = 2;
  let history = useHistory();
  const filteredItems = options1
    .slice(0, i)
    .concat(options1.slice(i + 1, options1.length));
  //
  const [statastics, setStatastics] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState("");
  const [menuu, setMenuu] = useState(menues);
  const [activeMenu, setActiveMenu] = useState(0);
  const themeColor = sessionStorage.getItem('role') == 'admin' ? '#077F83' : '';


  useEffect(() => {
    getCoachList(selectedFilter);
    getStatstics();
    console.log(selectedFilter,"selected filter")
  }, [selectedFilter])

  const getCoachList = (selectFilter:string) => {
    let filter =undefined;
    if(selectFilter){
      filter=selectFilter;
      if(selectFilter==="In Progress"){
        filter="In progress";
      }
      if(selectFilter==="to_be_started"){
        filter="Confirmed"
      }
      // if(selectFilter==="All"){
      //   filter="Received";
      // }
    }
    let params = { page: 1, count_per_page: 10,main_filter:filter };
    DataService.getDirectData("/assignments/list_coach_assignments", params)
      .then((res) => {
        filterData.length = 0;
        setFilterData(filterData.concat(res.assignments))
      })
  }
  const getStatstics = () => {
    let params = { type: "coach" };
    DataService.getDirectData("/assignments/statistics", params)
      .then((res) => {
        statastics.length = 0;
        setStatastics(statastics.concat(res.statistics))
      })
  }
  const fetchAssignmentsByStatistics = (value: any) => {
    let params = { page: 1, count_per_page: 10, main_filter: value === "All" ? "" : value };
    DataService.getDirectData("/assignments/list_coach_assignments", params)
      .then((res) => {
        filterData.length = 0;
        setFilterData(filterData.concat(res.assignments))
        setActiveMenu(()=>{
          let index = 0;
          // if(value !== "Received"){
            if(value === "Confirmed"){
            index= menues.findIndex(el=>el.label === "To be started")
            }
            // if(value === "Received"){
            //   index= menues.findIndex(el=>el.label === "All")
            //   }
            else{
            index= menues.findIndex(el=>el.label === value)
            }
          // }
          // else{
          //   index=-1;
          // }
          return index;
        })
      })
  }

  const getCoachByType = (index: any, apiLabel: any) => {
    setActiveMenu(index);
    setSelectedFilter(apiLabel)

  }
  ///

  const handleClick = (event: any) => {
    console.log("event", event.currentTarget);
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
    setCurrentSelection({});
  };

  const handleOption = (option: any) => {
    // setDropDownOption(option);
    if (option === "View summary") {
      setAction("view_summary");
      history.push({
        pathname: "assignmentsummary",
        state: { currentAssignment: currentSelection },
      });
    }
    if (option === "View details") {
      history.push({
        pathname: "assignmentoverview",
        state: { currentAssignment: currentSelection },
      });
    } else if (option === "Send on Cal, or Repair") {
      setAction("on_repair");
    } else if (option === "View Cert") {
      // window.open(`${BASE_API_URL}${currentSelection.calibration_certificate}`)
    } else {
      setAction(option);
    }
  };


  const handleClose = (data: any, id: any) => {
    let moduleList: any = [];
    if (action === "create" && data && data.id) {
      moduleList = [data].concat(modules);
      setModules(moduleList);
    } else if (data && data.id) {
      moduleList = modules.map((base: any) => {
        if (base.id === data.id) {
          return data;
        }
        return base;
      });
      setModules(moduleList);
    } else if (!data && id) {
      moduleList = modules.filter((base: any) => base.id !== id);
      setModules(moduleList);
    }
    setAction(null);
    setCurrentSelection({});
  };

  return (
    <div className={classes.bgGray}>
      <HomeHeaderMenu />
      <Grid container direction="row" alignItems="center" justify="center">
        <Grid item xs={10} style={{ padding: '20px 0' }}>
          <Typography variant="subtitle1" style={{ fontWeight: "bold" }} className={classes.title}>Quick statistics</Typography>
          <Typography variant='subtitle1' className={classes.subTitle}>Assignments</Typography>
        </Grid>
      </Grid>
      <Grid container direction="row" alignItems="center" spacing={2} justify="center">
        <Grid item xs={10} style={{ padding: '20px 0' }}>
          <Grid container direction="row" justify="center" spacing={2}>

            {statastics.length > 0 && statastics.map((e: any) => 
           <React.Fragment >
          {  e.label === "Received" ?
            "" :
            <Grid item xs={3}>
             {e.label !== "Received" && <Box component="button" boxShadow={2} borderLeft={3} borderColor={""} borderRadius={5} p={0} onClick={() => { fetchAssignmentsByStatistics(e.label) }} style={{ border: 0, borderColor: "#077F83", borderLeftWidth: 3, borderStyle: "solid", backgroundColor: "#fff", width: "100%", textAlign: "left", }}>
                {/* <Paper className={classes.paper}> */}
                <Grid container direction="row" style={{ padding: 24 }}>
                  <Grid item xs={6} style={{ textAlign: 'left' }}>
                    <Typography variant="h2" className={classes.cardTitle} style={{ color: "#320032" }}>{e.label}</Typography>
                    <Typography variant='subtitle1' className={classes.titleNumber} style={{ fontWeight: 'bold', color: "#320032" }}>{e.value}</Typography>
                  </Grid>
                  <Grid item xs={6} style={{ textAlign: 'right' }}>
                    <div className={classes.iconBg}>
                      <AddShoppingCart className={classes.cardIcon} />
                    </div>
                  </Grid>
                </Grid>
              </Box>}
            </Grid>}
            </React.Fragment>
            )}

          </Grid>

        </Grid>
      </Grid>

      <Grid container direction="row" alignItems="center" justify="center">
        <Grid item xs={10} style={{ padding: '20px 0', textAlign: 'center', borderBottom: '1px solid #70707040' }}>
          <Typography variant='h2'>
            {menuu.map((e, index) => <label className={activeMenu == index ? classes.activeMenuStyle : classes.menuTitle}
              onClick={() => getCoachByType(index, e.apiLabel)}
            >{e.label}</label>)}
          </Typography>


        </Grid>
      </Grid>

      <Grid container direction="row" alignItems="center" justify="center">
        <Grid item xs={10} style={{ padding: '20px 0', }}>

          <Grid container direction="row" alignItems="center" justify="flex-start" spacing={2}>
            {
              filterData.length > 0 ? filterData.map((option: any) => {
                console.log("option", option)
                return <Grid item xs={3} >
                  <Card variant="outlined">
                    <CardContent>
                      <Grid container direction="row" alignItems="flex-start">
                        <Grid item xs={12} >
                          <Typography variant="h2" className={classes.modelTitle}>{option.name}</Typography>
                          <Typography variant="h2" className={classes.modelTitleNumber}>{option.completed_percentage}%</Typography>
                        </Grid>
                        <Grid item xs={12} >
                          <Typography variant="h2" className={classes.subModelTitle}>{option.coach_job_title}</Typography>
                          <Typography variant="h2" className={classes.subModelTitleNumber}>Complete</Typography>
                        </Grid>
                        <Grid item xs={12} style={{ marginTop: 22 }}>
                          <LinearProgress variant="determinate" value={option.completed_percentage} />
                        </Grid>
                        <Grid item xs={12} style={{ marginTop: 20 }}>
                          <Grid container direction="row" alignItems="center" justify="center" spacing={2}>
                            <Grid item xs={2} >
                              <Avatar src={option.coachee_image} />
                            </Grid>
                            <Grid item xs={8} >
                              <Typography className={classes.userName}>{option.coachee_name}</Typography>
                              <Typography variant="h2" className={classes.userDesig}>{option.title}</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <IconButton
                                className={classes.textSecondary}
                                aria-label="more"
                                aria-controls={`long-menu-${option.id}`}
                                aria-haspopup="true"
                                onClick={(e) => {
                                  setCurrentSelection(option);
                                  handleClick(e);
                                }}
                              >
                                <MoreVertIcon />
                              </IconButton></Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                  <Menu
                    id={`long-menu`}
                    anchorEl={anchorEl}
                    keepMounted
                    open={open}
                    onClose={handleCloseMenu}
                    PaperProps={{
                      style: {
                        maxHeight: ITEM_HEIGHT * 4.5,
                        width: "20ch",
                        border:"2px solid white",
                        boxShadow:"1px 1px 5px rgba(0,0,0,0.02)"
                      },
                    }}
                  >
                    {currentSelection.calibration_certificate === null
                      ? filteredItems.map((option) => (
                        <MenuItem
                          key={option}
                          className={classes.textSecondary}
                          style={{ fontSize: "12px" }}
                          onClick={() => {
                            handleOption(option);
                          }}
                        >
                          {option}
                        </MenuItem>
                      ))
                      : options1.map((option) => (
                        <MenuItem
                          key={option}
                          className={classes.textSecondary}
                          style={{ fontSize: "12px" }}
                          onClick={() => {
                            handleOption(option);
                          }}
                        >
                          {option}
                        </MenuItem>
                      ))}
                  </Menu>
                  {action === "view_summary" && (
                    <ViewSummary
                      action={action}
                      // moduleId={data.id}
                      data={data}
                      handleClose={handleClose}
                    />
                  )}
                </Grid>

              })
: <div style={{margin:"0px auto"}}>No assignments found</div>
            }
          </Grid>
        </Grid>
      </Grid>

    </div >
  )
}
export default CoachHome;

const useStyles = makeStyles((theme) => ({

  bgGray: {
    backgroundColor: '#B4B4B40D',
    "& .MuiLinearProgress-colorPrimary": {
      backgroundColor: "rgb(234 234 234)"
    },
    "& .MuiLinearProgress-barColorPrimary": {
      backgroundColor: "#981B1E"
    },
  },
  title: {
    color: '#360940',
    margin: 0,
    marginBottom: 5
  },
  subTitle: {
    color: '#43425D80',
    fontSize: 16
  },
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    borderRadius: 0,
    margin: theme.spacing(2)
  },
  cardTitle: {
    color: '#43425D80',
    fontSize: 14
  },
  titleNumber: {
    margin: 0,
    color: '#4D4F5C'
  },
  iconBg: {
    width: 40,
    height: 40,
    float: 'right',
    borderRadius: 5,
    backgroundColor: "#320032",
    textAlign: 'center',
    padding: 5
  },
  cardIcon: {
    padding: 10,
    color: "#fff"
  },
  menuTitle: {
    paddingLeft: 45,
    paddingRight: 45,
    color: '#43425D80',
    fontSize: 15
  },
  modelTitle: {
    color: '#360940',
    fontSize: 18,
    fontWeight: 'bold'
  },
  modelTitleNumber: {
    color: '#981B1E',
    fontSize: 18,
    fontWeight: 'bold',
    float: 'right'
  },
  subModelTitle: {
    color: '#70707080',
    fontSize: 12
  },
  subModelTitleNumber: {
    color: '#360940',
    fontSize: 12,
    float: 'right'
  },
  root1: {
    width: '100%',
  },
  userName: {
    color: '#232323',
    fontSize: 15,
    lineHeight: 1
  },
  userDesig: {
    color: '#70707080',
    fontSize: 12
  },
  activeMenuStyle: {
    padding: 20,
    borderBottom: '1px solid #981B1E',
    color: '#981B1E'
  },
  activeCard: {
    borderLeft: '2px solid #981B1E'
  },
  textSecondary: {
    color: theme.palette.secondary.main
  },
}))
